import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { SuperAppCmsService } from "../../../service/super-app-cms-service";

const createOrder = ({ secureToken, payload }) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createSellerPackageV2Order(secureToken, payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

const getSellerPackageCmsData = (payload) => () => {
    return new Promise((resolve, reject) => {
        SuperAppCmsService.getCmsData(payload)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

// eslint-disable-next-line no-unused-vars
const getSellerPackageProductPageDetails = (token, headers = {}) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getSellerPackageProductPage(token, headers).then(response => {
            resolve(response);
        }).catch((e) => {
            reject(e);
        });
    });
};

export {
    createOrder,
    getSellerPackageCmsData,
    getSellerPackageProductPageDetails
};
